// src/Home.jsx
import Landing from './landing/Landing';

const Home = ({ setCurrentPage }) => <Landing setCurrentPage={setCurrentPage} />;

export default Home;
